import { render } from "./Stepper.vue?vue&type=template&id=32fde2f7&scoped=true"
import script from "./Stepper.vue?vue&type=script&lang=ts"
export * from "./Stepper.vue?vue&type=script&lang=ts"

import "./Stepper.vue?vue&type=style&index=0&id=32fde2f7&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-32fde2f7"

export default script